module.exports = __webpack_public_path__ + "static/img/sousuo.4c36d99.png";


//////////////////
// WEBPACK FOOTER
// ./src/apponeselfplug/search/sousuo.png
// module id = 1010
// module chunks = 1